import { Money } from '../utils/money.model';

export interface Activity {
  id: string;
  order: number;
  name: string;
  masterActivityIds: string[];
  markup: number;
  color: string;
  outsideOfContract: boolean;
  hiddenPhaseIds: string[];

  correctionHourlyCost: Money;
  correctionMaterial: Money;
}

export const activityChatbotFields = {
  id: { type: 'string', description: 'Must be specified for update or delete.' },
  name: {
    type: 'string',
    description: 'Must be specified for new entries. Otherwise should be only set if the intend it to change it.',
  },
  order: { type: 'number', description: 'Optional. Describes the order in the list.' },
  masterActivityIds: {
    type: 'array',
    description: 'Optional. Master project activity ids linked to this activity. Set [] to remove master links.',
    items: { type: 'string' },
  },
};
